import { cdnClient, client, ContentTypes, Query, ResponseData } from '../galaxyClient';

type Filters = Query<ContentTypes, '/v2/categories/statistics', 'get'>;
export const getCategoryStatisticsFromDonation = async ({
  paymentRequestId,
  subscriptionId,
}: Filters) => {
  const { data } = await client().content.GET('/v2/categories/statistics', {
    params: { query: { paymentRequestId, subscriptionId } },
  });
  return data;
};

export type Category = ResponseData<ContentTypes, '/v2/categories/{id}', 'get'>;
type CategoriesFilters = Query<ContentTypes, '/v2/categories/', 'get'>;
export const getCategories = async ({
  id,
  q,
  status,
  impacterId,
  initiativeId,
  locale,
  pillarId,
  tagId,
  skipContentfulData,
}: CategoriesFilters) => {
  const { data } = await client().content.GET('/v2/categories/', {
    params: {
      query: {
        id,
        q,
        status,
        impacterId,
        initiativeId,
        locale,
        pillarId,
        tagId,
        skipContentfulData,
      },
    },
  });
  return data;
};

type CategoryFilters = Query<ContentTypes, '/v2/categories/{id}', 'get'>;
export const getCategory = async (id: string, query?: CategoryFilters) => {
  const { data } = await cdnClient().content.GET('/v2/categories/{id}', {
    params: {
      path: { id },
      query,
    },
  });

  return data;
};
